<template>
  <div class="chapter-picker" ref="chapterPicker">
    <swiper :options="swiperOptions" @click="selectChapter" ref="mySwiper">
      <swiper-slide
        v-for="(item, index) in items.slice().reverse()"
        :key="index + 1"
        class="chapter-item"
        :id="item.id"
        :class="selectedChapter === item.id ? 'selected' : ''"
      >
        <div class="content">
          <div class="supertitle">MONS {{ index + 1 }}:</div>
          <div class="title">{{ item.chapterTranslations[0].title }}</div>
        </div>
      </swiper-slide>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  name: 'chapter-picker',
  components: {
    swiper,
    swiperSlide
  },
  props: {
    name: String,
    items: Array,
    language: String,
    initialItem: Object
  },
  data: function() {
    return {
      selectedChapter: undefined,
      swiperOptions: {
        slidesPerView: 4,
        spaceBetween: 0,
        centeredSlides: true,
        grabCursor: true,
        preventClicks: false,
        slideToClickedSlide: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  mounted: function() {
    if (this.items.length > 0) {
      this.selectedChapter = this.items[0].id
    }
  },
  methods: {
    selectChapter: function(chapterId) {
      this.selectedChapter = this.$refs.mySwiper.swiper.clickedSlide.getAttribute('id')
    }
  },
  watch: {
    initialItem: function() {
      this.selectedChapter = this.initialItem.id
    },
    items: function() {},
    selectedChapter: function() {
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].id === this.selectedChapter) {
          this.$refs.mySwiper.swiper.slideTo(this.items.length - i - 1)
          break
        }
      }

      this.$parent.$emit('chapterChanged', this.selectedChapter)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/_vars.scss';

.chapter-picker::-webkit-scrollbar {
  display: none;
}

.chapter-picker {
  display: flex;
  -ms-overflow-style: none; // IE 10+
  overflow: -moz-scrollbars-none; // Firefox
  overflow: scroll;
}

.chapter-item {
  border-right: 1px solid $light-gray;
  background: white;
  transition: all 0.2s ease-out;
  cursor: pointer;

  .content {
    padding: 1rem;
  }

  .title {
    font-weight: bold;
    line-height: 1.25;
    font-size: 0.85rem;
  }

  .supertitle {
    font-size: 0.8rem;
    color: $medium-gray;
  }

  &:hover {
    background: lighten($primary-color, 60%);
  }

  &.selected {
    background: $primary-color;
    * {
      color: white;
    }
  }
}

.bg-primary {
  select {
    background: darken($primary-color, 5%) url('/static/images/icon-arrow-down-white.png') no-repeat
      right;
  }
}

.swiper-button-next,
.swiper-button-prev {
  background-color: rgba(0, 0, 0, 0.1);
  height: 102%;
  margin-top: 0;
  width: 64px;
  margin-top: -1px;
  transform: translateY(-50%);

  &:hover {
    background-color: rgba(0, 0, 0, 0.2);
  }
}

.swiper-button-next {
  right: 0;
}
.swiper-button-prev {
  left: 0;
}

select {
  max-width: 100%;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background: #fff url('/static/images/icon-arrow-down.png') no-repeat right;
  background-position-x: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  border: none;
  border-radius: 0;
  text-transform: uppercase;
  font-size: 0.75rem;
  font-weight: $bold;
  padding: 0 1.5rem 0 0;
  margin: 0;
  color: $txt-color-primary;

  &:focus {
    outline: none;
  }

  option {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

i {
  display: none;
  @media (max-width: $device-md) {
    // display: none;
  }
}
</style>



// WEBPACK FOOTER //
// ChapterPicker.vue?19d701eb